import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

export interface OverrideDoorIdDialogData {
  deviceId: string;
}

@Component({
  selector: 'app-override-door-id-dialog',
  standalone: true,
  templateUrl: './override-door-id-dialog.component.html',
  styleUrls: ['./override-door-id-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule, MatDialogModule],
})
export class OverrideDoorIdDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<OverrideDoorIdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OverrideDoorIdDialogData
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
